import { flow, Instance, types } from 'mobx-state-tree'
import { appAuthGenerate, appAuthVerify } from '../../network/AppAuthPkce'
import { appExpireReq } from '../../network/appExpireReq'
import { generateEmailOtp } from '../../network/generateEmailOtp'
import { loginRequest } from '../../network/loginRequest'
import { logoutRequest } from '../../network/logoutRequest'
import { verifyEmailOtp } from '../../network/verifyEmailOtp'
import { MessageTypes, pkceGenerateRandomString } from '../../utils'
import { RootStore } from '../store'
import { Error } from './../../../../../flows/mportal/src/assets/images/svg/Error'
import { updateBaseUrl } from './../../network/config'

const Session: any = types
  .model('Session', {
    appAccessToken: types.optional(types.string, ''),
    appRefreshToken: types.optional(types.string, ''),
    appAccessTokenExpiry: types.optional(types.number, -1),
    appRefreshTokenExpiry: types.optional(types.number, -1),
    appIdToken: types.optional(types.string, ''),
    authorizationCode: types.optional(types.string, ''),
    usrAccessToken: types.optional(types.string, ''),
    usrRefreshToken: types.optional(types.string, ''),
    usrAccessTokenExpiry: types.optional(types.number, -1),
    usrRefreshTokenExpiry: types.optional(types.number, -1),
    usrIdentifierToken: types.optional(types.string, ''),
    isCitrixIp: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    generateVerifyPKCE: flow(function* generateVerifyPKCE(username: string, password: string) {
      let response
      try {
        const own = self
        const codeVerifier = pkceGenerateRandomString(64)
        let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.session.getTokens)
        if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
          own.authorizationCode = resAppAuthGen?.authorizationCode
          let resAppAuthVerify = yield appAuthVerify(
            own.authorizationCode,
            codeVerifier.toString(),
            RootStore.session.getTokens,
          )
          if (resAppAuthVerify.status === 'SUCCESS') {
            own.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
            own.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
            own.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
            own.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
            own.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
            let loginResp = yield loginRequest(username, password, RootStore.session.getTokens)
            if (loginResp.status === 'SUCCESS') {
              const session = loginResp?.session
              own.usrAccessToken = session?.accessToken?.tokenValue ?? ''
              own.usrRefreshToken = session?.refreshToken?.tokenValue ?? ''
              own.usrAccessTokenExpiry = session?.accessToken?.expiresIn ?? -1
              own.usrRefreshTokenExpiry = session?.refreshToken?.expiresIn ?? -1
              own.usrIdentifierToken = session?.identifierToken ?? ''
              RootStore.user.setUserName(loginResp?.jfsUserId ?? username)
              localStorage.setItem('userEmailId', loginResp?.jfsUserId ?? username)
            }
          }
        }
        response = own
        localStorage.setItem('sessionData', JSON.stringify(own))
        return response
      } catch (e) {
        const error = e?.data?.error
        RootStore.message.setMessage(error?.message ?? 'Error while processing request', MessageTypes.ERROR)
      }
      return response
    }),
    generateOtp: flow(function* generateOtp(emailId: string) {
      let response
      try {
        const own = self
        const codeVerifier = pkceGenerateRandomString(64)
        let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.session.getTokens)
        if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
          own.authorizationCode = resAppAuthGen?.authorizationCode
          let resAppAuthVerify = yield appAuthVerify(
            own.authorizationCode,
            codeVerifier.toString(),
            RootStore.session.getTokens,
          )
          if (resAppAuthVerify.status === 'SUCCESS') {
            own.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
            own.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
            own.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
            own.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
            own.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
            yield generateEmailOtp(emailId, RootStore.session.getTokens)
          }
        }
        return response
      } catch (e) {
        const error = e?.data?.error
        RootStore.message.setMessage(error?.message ?? 'Error while processing request', MessageTypes.ERROR)
        throw e
      }
    }),
    verifyOtp: flow(function* verifyOtp(emailId: string, otp: string) {
      let response
      try {
        const own = self
        let loginResp = yield verifyEmailOtp(emailId, otp, RootStore.session.getTokens)
        if (loginResp.status === 'SUCCESS') {
          const session = loginResp?.session
          own.usrAccessToken = session?.accessToken?.tokenValue ?? ''
          own.usrRefreshToken = session?.refreshToken?.tokenValue ?? ''
          own.usrAccessTokenExpiry = session?.accessToken?.expiresIn ?? -1
          own.usrRefreshTokenExpiry = session?.refreshToken?.expiresIn ?? -1
          own.usrIdentifierToken = session?.identifierToken ?? ''
          RootStore.user.setUserName(loginResp?.jfsUserId ?? emailId)
          localStorage.setItem('userEmailId', loginResp?.jfsUserId ?? emailId)
        }
        response = own
        localStorage.setItem('sessionData', JSON.stringify(own))
        return response
      } catch (e) {
        const error = e?.data?.error
        RootStore.message.setMessage(error?.message ?? 'Error while processing request', MessageTypes.ERROR)
        throw e
      }
    }),
    login: flow(function* login(username: string, password: string) {
      let response
      try {
        response = yield loginRequest(username, password, RootStore.session.getTokens)
        const session = response?.session
        const own = self
        own.usrAccessToken = session?.accessToken?.tokenValue ?? ''
        own.usrRefreshToken = session?.refreshToken?.tokenValue ?? ''
        own.usrAccessTokenExpiry = session?.accessToken?.expiresIn ?? -1
        own.usrRefreshTokenExpiry = session?.refreshToken?.expiresIn ?? -1
        own.usrIdentifierToken = session?.identifierToken ?? ''
        localStorage.setItem('sessionData', JSON.stringify(own))
        RootStore.user.setUserName(response?.jfsUserId ?? username)
        localStorage.setItem('userEmailId', response?.jfsUserId ?? username)
        return response
      } catch (error) {
        console.log('Error ', error?.message ?? 'Error while processing request')
        RootStore.message.setMessage(error?.message ?? 'Error while processing request', MessageTypes.ERROR)
        return response
      }
    }),
    logout: flow(function* logout(ignoreError = false) {
      console.log('darshan logout called')
      let response
      try {
        const getSessionValidateRequestBody = (data: any) => {
          return {
            accessToken: data?.usrAccessToken ?? '',
            refreshToken: data?.usrRefreshToken ?? '',
            userIdentifierToken: data?.usrIdentifierToken ?? '',
          }
        }
        if (!ignoreError) {
          yield logoutRequest(getSessionValidateRequestBody(self), RootStore.session.getTokens)
          const getAppExpireRequestBody = (data: any) => {
            return {
              accessToken: data?.appAccessToken ?? '',
            }
          }
          response = yield appExpireReq(getAppExpireRequestBody(self), RootStore.session.getTokens)
        }
      } catch (error) {
        if (!ignoreError) {
          throw new Error(error?.message ?? 'Error while processing logout request')
        }
      } finally {
        ;(self as any).updateAllSessionData({})
        localStorage.removeItem('sessionData')
        localStorage.removeItem('accessConfig')
        const isCitrixIp = localStorage.getItem('isCitrixIp')
        localStorage.clear()
        localStorage.setItem('isCitrixIp', isCitrixIp)
      }
      return response
    }),
    updateAppSessionData(
      appAccessToken: string,
      appRefreshToken: string,
      appAccessTokenExpiry: number,
      appRefreshTokenExpiry: number,
      appIdToken: string,
    ) {
      const own = self
      own.appAccessToken = appAccessToken
      own.appRefreshToken = appRefreshToken
      own.appAccessTokenExpiry = appAccessTokenExpiry
      own.appRefreshTokenExpiry = appRefreshTokenExpiry
      own.appIdToken = appIdToken
      localStorage.setItem('sessionData', JSON.stringify(own))
    },
    updateUsrSessionData(
      usrAccessToken: string,
      usrRefreshToken: string,
      usrAccessTokenExpiry: number,
      usrRefreshTokenExpiry: number,
      usrIdToken: string,
    ) {
      const own = self
      own.usrAccessToken = usrAccessToken
      own.usrRefreshToken = usrRefreshToken
      own.usrAccessTokenExpiry = usrAccessTokenExpiry
      own.usrRefreshTokenExpiry = usrRefreshTokenExpiry
      own.usrIdentifierToken = usrIdToken
      localStorage.setItem('sessionData', JSON.stringify(own))
      console.log(
        'updateUsrSessionData',
        usrAccessToken,
        usrRefreshToken,
        usrAccessTokenExpiry,
        usrRefreshTokenExpiry,
        usrIdToken,
      )
    },
    updateAllSessionData(data: any) {
      const own = self
      own.appAccessToken = data?.appAccessToken ?? ''
      own.appRefreshToken = data?.appRefreshToken ?? ''
      own.appAccessTokenExpiry = data?.appAccessTokenExpiry ?? -1
      own.appRefreshTokenExpiry = data?.appRefreshTokenExpiry ?? -1
      own.appIdToken = data?.appIdToken ?? ''
      own.usrAccessToken = data?.usrAccessToken ?? ''
      own.usrRefreshToken = data?.usrRefreshToken ?? ''
      own.usrAccessTokenExpiry = data?.usrAccessTokenExpiry ?? -1
      own.usrRefreshTokenExpiry = data?.usrRefreshTokenExpiry ?? -1
      own.usrIdentifierToken = data?.usrIdentifierToken ?? ''
      localStorage.setItem('sessionData', JSON.stringify(own))
    },

    updateIsCitrixIp(val: string) {
      self.isCitrixIp = val === 'true'
      updateBaseUrl(self.isCitrixIp)
    },
  }))
  .views((self) => ({
    get getTokens() {
      return {
        appAccToken: self.appAccessToken,
        appIdToken: self.appIdToken,
        userAccessToken: self.usrAccessToken,
        userIdToken: self.usrIdentifierToken,
      }
    },
    isValidSession() {
      if (
        !!self?.appAccessToken &&
        !!self.appRefreshToken &&
        !!self.appIdToken &&
        !!self.usrAccessToken &&
        !!self.usrRefreshToken &&
        !!self.usrIdentifierToken
      ) {
        return true
      }
      return false
    },
  }))

const sessionData = Session.create({
  appAccessToken: '',
  appRefreshToken: '',
  appAccessTokenExpiry: -1,
  appRefreshTokenExpiry: -1,
  appIdToken: '',
  authorizationCode: '',
})

export type SessionV2 = Instance<typeof Session>
export { Session, sessionData }
